import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import useGlobalContext from "hooks/globalData";
import { ResponseCode } from "services/KnowfullyAdminClient";
import { CircularProgress } from "@mui/material";

const UserCourseDeepLink = () => {
  const { userSkuId } = useParams<{ userSkuId: string }>();
  const { userSkuService, userCourseUrl, errorUrl } = useGlobalContext();
  const navigate = useNavigate();

  const { data: userIdResponse, isFetched } = useQuery(
    ["userSkuService.getUserId", userSkuId],
    () => userSkuService.getUserId(userSkuId!),
    { enabled: !!userSkuId }
  );

  useEffect(() => {
    if (!isFetched) {
      return;
    }

    if (userIdResponse?.responseCode === ResponseCode.OK) {
      navigate(userCourseUrl(userIdResponse.data, userSkuId), { replace: true });
    } else {
      navigate(errorUrl(), { replace: true });
    }
  }, [isFetched, userIdResponse, navigate, userCourseUrl, errorUrl, userSkuId]);

  return <CircularProgress />;
};

export default UserCourseDeepLink;
